import React from 'react'

const defaultProps = {
  height: '80',
  width: '80',
}

const IconLoggedUsers = (props) => {
  const height = props.height || defaultProps.height
  const width = props.width || defaultProps.width
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        {/* Main user (center) */}
        <circle cx="40" cy="36" r="10" fill="#fff" />
        {/* Shoulders/body */}
        <ellipse cx="40" cy="54" rx="16" ry="10" fill="#fff" />
        {/* Left user */}
        <circle cx="24" cy="40" r="6" fill="#fff" fillOpacity="0.7" />
        <ellipse cx="24" cy="54" rx="8" ry="6" fill="#fff" fillOpacity="0.7" />
        {/* Right user */}
        <circle cx="56" cy="40" r="6" fill="#fff" fillOpacity="0.7" />
        <ellipse cx="56" cy="54" rx="8" ry="6" fill="#fff" fillOpacity="0.7" />
      </g>
    </svg>
  )
}

export default IconLoggedUsers
